import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
 invoiceNumber:'',
};

export const InvoiceSearchFields = {
  name: "Invoice Filter",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Draft Invoices Filter Details Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Contact Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-3",
          },
          groupWrapper: <div className="form-card row ml-1 mr-2"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "invoiceNumber",
              label: "Invoice Number :",
              Field_Name: "Invoices Number",
              fieldType: FormFieldTypes.INPUT,
              dataField: "invoiceNumber",
              fieldSetting: {
                placeholder: "Select Invoice Number",
                options: [],
              },
              style: { containerCss: "col-xl-4 col-lg-4 col-md-5 col-12" },
            },
            
          ],
        },
        
      ],
    },
  ],
};
